export default __webpack_public_path__ + "static/media/maybelline.322c0893.jpg";